import React from 'react';
import PropTypes from 'prop-types';
import customerApprovalService from '../customer-approvals/customerApprovalService';
import { CustomerApprovalFilter } from '../customer-approvals/customerApprovalFilter';
import { withRouter } from 'react-router-dom';
import CustomerApprovalPanelItem from './CustomerApprovalPanelItem';
import { ButtonGroup, Button } from 'reactstrap';
import CustomApprovalLinkModalComponent from './CustomApprovalLinkModalComponent';
import { OrderView } from '../orders/order';
import { appConfig } from '@ami/react/core';

class CustomerApprovalPanel extends React.Component {
  static propTypes = {
    entity: PropTypes.instanceOf(OrderView).isRequired,
  };

  state = {
    loading: false,
    filter: new CustomerApprovalFilter(),
    items: [],
    showModal: false,
    approvalRequestId: '',
  };

  async componentDidMount() {
    const { filter } = this.state;
    filter.relatedId = this.props.entity.id;
    this.setState({ filter });
    this.search();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.entity !== this.props.entity) {
      this.search();
    }
  }

  search() {
    this.loadPage();
  }

  loadPage() {
    if (!this.state.loading) {
      this.setState({ loading: true });
    }
    customerApprovalService.search(this.state.filter).then((items) =>
      this.setState({
        items: items,
        loading: false,
      })
    );
  }

  getApprovalLink = () => {
    OrderView.getApprovalRequestId(this.props.entity.id)
      .then((approvalRequestId) =>
        this.setState({ approvalRequestId: approvalRequestId })
      )
      .finally(() => this.setState({ showModal: true }));
  };

  handleHideModal = () => this.setState({ showModal: false });

  render() {
    const { items, showModal, approvalRequestId, loading } = this.state;
    const { entity } = this.props;
    return (
      <div className="col">
        <div className="card mb-4 box-shadow h-100">
          <div className="card-body">
            <h6 className="card-title text-center">Customer Approvals</h6>
            {!loading && items.length === 0 && (
              <div className="row">
                <div className="col text-center">No customer approvals</div>
              </div>
            )}
            {!loading && items.length !== 0 && (
              <div className="recent-list-wrapper pb-0">
                <ul className="list-unstyled">
                  {items.map((entity, i) => (
                    <CustomerApprovalPanelItem
                      key={items.length - i}
                      entity={entity}
                    />
                  ))}
                </ul>
              </div>
            )}
            {!loading && appConfig.isManagementApp && items.length > 0 && (
              <div className="row">
                <div className="col text-center">
                  <ButtonGroup>
                    <Button
                      color="outline-primary"
                      onClick={this.getApprovalLink}
                    >
                      Get Approval Link
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            )}
            {loading && (
              <li className="row">
                <div className="col-12">
                  Loading... <i className="fa fa-spin fa-spinner" />
                </div>
              </li>
            )}
          </div>
          <CustomApprovalLinkModalComponent
            entity={entity}
            showModal={showModal}
            hideModal={this.handleHideModal}
            approvalRequestId={approvalRequestId}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(CustomerApprovalPanel);
